import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Container, Row, Col } from 'react-bootstrap';
import Banner from 'components/Header/Banner'
import { Outlet, } from 'react-router-dom';
import { loginlink as bankIdSubLink } from './methods/BankID';
import './style.scss';

export const path = '/registration';
export const link = path;//.replace('','');
export const bankIdLink = `${link}/${bankIdSubLink}`;

const Registration = () => {
    return (
    <CSSTransition in={true} appear={true} timeout={200} classNames="zt-page__transition">
        <Container className='zt-registration'>
            <Row>
                <Col md={{ span: 8, offset: 2}} lg={{ span: 6, offset: 3 }} >
                    <Outlet />
                    <div className='zt-registration__banner'>
                        <Banner />
                    </div>
                </Col>
            </Row>
        </Container>
    </CSSTransition>
    );
}

Registration.path = path;
Registration.link = link;
Registration.bankIdLink = bankIdLink;

export default Registration;